<template>
  <div class="onboarding-page">
    <div class="page-wrapper">
      <router-view/>
    </div>
  </div>
</template>

<script>
export default {
  name: 'OnbaordingPage',
  data() {
    return {
      active: 0,
    };
  },
  beforeMount() {
    window.eventBus.$on('onboarding-step-change', (step) => {
      this.active = step;
    });
  },
};
</script>

<style lang="scss">
@import "../assets/scss/variables.scss";

.onboarding-page {
  // padding: 48px 0 0 0;

  .el-steps--horizontal {
    justify-content: center;
  }

  .el-step.is-horizontal:not(:last-child) {
    flex-basis: 161px !important;

    .el-step__line {
      top: 15px;
    }
  }

  .el-step__icon {
    height: 32px;
    width: 32px;
  }

  .el-step__head.is-success {
    color: inherit;
    border-color: inherit;

    .el-step__icon {
      border-color: $black;
      color: $black;
    }
  }
  .el-step__head.is-process {
    .el-step__icon {
      border-color: $blue;
      color: $blue;
    }
  }
  .page-wrapper {
    // margin: 48px 0 57px 0;
    //margin: 4rem 0;
  .el-form {
      max-width: 414px;
      width: 100%;
      margin: auto;
    }
  }
  .el-form-item {
    // margin-bottom: 16px !important;
    .el-form-item__label {
      font-size: 16px;
      line-height: 28px;
      color: $black;

      &:before {
        content: none !important;
      }
    }

    .el-form-item{
      margin-bottom: 0px !important;
    }

    .el-input, .el-select {
      font-size: 16px;
      width: 100%;
    }

    .el-input__inner {
      height: 48px;
      line-height: 48px;
      border-radius: 8px;
      color: $black;
    }

    .helper-text, .error-msg {
      font-size: 13px;
      line-height: 18px;
      color: $gray;
    }
    .error-msg {
      color: #f56c6c;
    }
  }
  .el-form-item.no-margin {
    margin-bottom: 0;
  }
  .el-form-item.is-error {
    .helper-text {
      color: #f56c6c;
    }
  }

  .sub-header {
    color: $black;
    margin-bottom: 40px;
  }
  .action-buttons {
    .el-button.is-disabled, .el-button.is-disabled:hover {
      background-color: #AFE7F1;
      border-color: #AFE7F1;
    }
    // .el-button {
    //   padding: 15px 30px;
    //   min-width: 126px;
    //   font-size: 18px;
    // }
    // .el-button.btn-transparent {
    //   border-color: $black;
    // }
  }
}

@media (max-width: 567px) {
  .onboarding-page{
    padding: 0;
    .page-wrapper {
      margin: 32px 0 57px 0;
    }
  }
}

</style>



// WEBPACK FOOTER //
// app/src/pages/Onboarding.vue